module.exports = __webpack_public_path__ + "img/slippers_of_halcyon.81556c79.png";